import { DropdownItem } from 'reactstrap';
import { useMutation } from '@tanstack/react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faBellSlash } from '@fortawesome/free-solid-svg-icons';
import i18n from '@s20/i18n';
import { useDispatch, useSelector } from '@s20/hooks/redux.hooks';
import { getPermissionStrings } from '@s20/selectors/features/permissions.selectors';
import { getUser } from '@s20/selectors/features/common.selectors';
import { setUser } from '@s20/slices/features/common.slice';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes, ApplicationPermissions } from '../Common';
import { toasty } from '../common/forms/FormElements';

export const DispatchPlusNotificationSubscription = () => {
    const dispatch = useDispatch();
    const user = useSelector(getUser);
    const permissions = useSelector(getPermissionStrings);

    const { mutate: updateSubscription } = useMutation({
        mutationFn: (next) => httpClient.put(
            ApiRoutes.auth.updateDispatchPlusNotificationSubscription(),
            { isSubscribed: next },
        ),
        onSuccess: (_data, next) => {
            dispatch(setUser({ ...user, isSubscribedToDispatchPlusNotifications: next }));
            toasty.success(i18n.t('nav:dispatchPlusNotificationSubscriptionSaved'));
        },
        onError: (err) => {
            console.error({ err });
            toasty.error(i18n.t('nav:dispatchPlusNotificationSubscriptionSaveError'));
        },
    });

    if (!permissions.includes(ApplicationPermissions.notification_dispatch_plus)) {
        return null;
    }

    const isSubscribed = Boolean(user?.isSubscribedToDispatchPlusNotifications);

    return (
        <DropdownItem onClick={() => updateSubscription(!isSubscribed)}>
            <FontAwesomeIcon
                icon={isSubscribed ? faBellSlash : faBell}
            />

            {isSubscribed ? i18n.t('nav:unsubscribeDispatchPlusNotifications') : i18n.t('nav:subscribeDispatchPlusNotifications')}
        </DropdownItem>
    );
};
